import ContentBin from './ContentBin'

export default ContentBin
